<template>
  <ul class="pl-0 attachment-list">
    <li
      v-for="attachmentDetails in messageAttachments"
      class="mt-1"
      :key="attachmentDetails.id"
    >
      <message-attachment
        v-if="isReferenceAttachment(attachmentDetails)"
        :attachmentDetails="attachmentDetails"
      />

      <code-block-attachment
        v-else-if="isCodeSnippetAttachment(attachmentDetails)"
        :attachmentDetails="attachmentDetails"
      />
      <div v-else-if="noMessageContent(attachmentDetails)">
        <v-icon>attachment</v-icon>
        <span class="no-attachment-text font12 font300 ml-1">{{
          $message.DISPLAY_MESSAGE_FOR_UNSUPPORTED_MESSAGE_ATTACHMENTS
        }}</span>
      </div>
    </li>
  </ul>
</template>
<script>
const MessageAttachment = () =>
  import(
    '@/components/ArchiveSearch/ChatBox/MessageAttachmentsList/MessageAttachment'
  );
const CodeBlockAttachment = () =>
  import(
    '@/components/ArchiveSearch/ChatBox/MessageAttachmentsList/CodeBlockAttachment'
  );
// All possible content types for attachments
const contentTypes = [
  'reference',
  'codeSnippet',
  'announcement',
  'messageReference'
];
export default {
  name: 'message-attachments-list',

  components: { MessageAttachment, CodeBlockAttachment },

  props: {
    messageAttachments: Array
  },

  data() {
    return {
      displayMessageForUnsupportedAttachments:
        '~ This media type is not compatible with Xift ~'
    };
  },

  computed: {
    isReferenceAttachment() {
      return attachmentDetails =>
        attachmentDetails?.contentType?.includes('reference');
    },
    noMessageContent() {
      return attachmentDetails =>
        !contentTypes?.includes(attachmentDetails?.contentType);
    },
    isCodeSnippetAttachment() {
      return attachmentDetails =>
        attachmentDetails?.contentType?.includes(
          'application/vnd.microsoft.card.codesnippet'
        );
    }
  }
};
</script>
<style lang="scss" scoped>
.attachment-list {
  list-style: none;

  a {
    text-decoration: none;
    color: #323d68;

    &:hover {
      text-decoration: underline;
    }
  }

  .no-attachment-text {
    font-style: italic;
    color: rgba(27, 35, 66, 0.6);
  }
}
</style>
